<template>
  <ul :class="['menu-utils', { 'light-mode': isLightMode }]">
    <li class="util-language">
      <lang-selector ref="langSel"
        :selected="language"
        :isPulse="isLoadingLang"
        @change="onLangSelection"
      />
    </li>
    <template v-if="isSocialIcons">
      <li class="util-social">
        <a href="https://github.com/hqcasanova">
          <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="979.9" height="958.3" viewBox="0 0 979.9 958.3"><path fill="currentColor" d="M490 47.6c244.2 0 442.3 198.1 442.3 442.3 0 195.3-126.7 361.1-302.4 419.9-2.7.5-5.2.7-7.5.7-16.6 0-22.4-11.9-22.4-22V767c0-41.5-13.8-68-30-81.8 98.5-10.9 202.2-48.4 202.2-218.3 0-48.4-17.3-88.1-45.5-118.6 4.6-11.5 19.6-56.4-4.6-117.5-3.4-1.1-7.2-1.5-11.3-1.5-40.4 0-110.3 47-110.3 47-35.1-9.8-73.1-15-110.6-15s-75.5 5.2-110.6 15c0 0-69.8-47-110.7-47-4.1 0-8 .5-11.4 1.5-23.6 61.1-8.6 106-4 117.5-28.2 30.5-45.5 70.3-45.5 118.6 0 169.3 103.1 207.4 201.6 218.3-12.7 11.5-24.2 30.5-28.2 59.3-11.2 5.1-30 11.7-50.9 11.7-26.4 0-56-10.7-77.6-48.6-24.2-42-68-45.5-68-45.5h-1.3c-41.1 0-1.6 27.1-1.6 27.1 28.8 13.2 49 64.5 49 64.5 15.5 47.2 65.9 56.7 103.8 56.7 25.5 0 45.4-4.3 45.4-4.3 0 36.9.6 72 .6 82.4 0 10.1-6.2 22-23 22-2.3 0-4.8-.2-7.5-.7C174.4 851.1 47.7 685.2 47.7 490 47.7 245.8 245.8 47.6 490 47.6M490 0c-66.1 0-130.3 13-190.7 38.5-58.3 24.7-110.7 60-155.7 105-45 45-80.3 97.4-105 155.7C13 359.7 0 423.9 0 490c0 52.9 8.4 105 25 154.8 16 48.2 39.4 93.4 69.5 134.5 29.7 40.6 65.4 76.3 105.9 106.1 41.1 30.2 86.3 53.6 134.5 69.7l3.3 1.1 3.4.6c5.4 1 10.8 1.5 16 1.5 21.5 0 40.7-8.4 53.9-23.8 10.8-12.5 16.7-28.8 16.7-45.9 0-3.8-.1-10.3-.2-19.2-.2-16.6-.4-39.3-.4-63.1v-50.2l.7-4.9c2.6-18.7 9.3-27.3 13.1-30.7l46.9-42.6 50.8 43.5c2.2 1.9 13.3 13.1 13.3 45.6v121.5c0 39.7 30.1 69.7 70.1 69.7 5.2 0 10.5-.5 15.9-1.5l3.4-.6 3.3-1.1c48.1-16.1 93.4-39.6 134.4-69.7 40.6-29.8 76.2-65.5 105.9-106.1 30.1-41.1 53.5-86.4 69.5-134.5 16.6-49.8 25-101.9 25-154.8 0-66.1-13-130.3-38.5-190.7-24.7-58.3-60-110.7-105-155.7-45-45-97.4-80.3-155.7-105C620.3 12.9 556.1 0 490 0Zm-.3 646.2-75.1-8.3c-52-5.8-87.7-18.1-112.3-38.9-31.5-26.5-46.9-69.7-46.9-132.1 0-33.7 11.1-62.7 32.8-86.3l20.4-22.1-11.2-27.9c-1.7-4.2-7.6-21.3-4.7-47 6.6 2.6 14.5 6.2 23.8 11 20.1 10.4 36.1 21.1 36.3 21.2l18.2 12.3 21.1-5.9c31.1-8.7 64.9-13.2 97.8-13.2 32.9 0 66.7 4.6 97.8 13.2l21.3 5.9 18.2-12.3c.1-.1 16.2-10.8 36.2-21.2 9.4-4.9 17.2-8.4 23.6-11 3.1 25.7-2.8 42.8-4.5 47l-11.2 27.9 20.4 22.1c21.8 23.6 32.8 52.6 32.8 86.3 0 62.5-15.4 105.7-47.1 132.2-24.7 20.6-60.5 32.9-112.7 38.7z"/></svg>
        </a>
      </li>
      <li class="util-social">
        <a :href="locale.urls.linkedin">
          <svg xmlns="http://www.w3.org/2000/svg" width="1949.333" height="1949.333" viewBox="0 0 1462 1462"><path fill="currentColor" d="M707 2.2C580.2 5.6 452.5 44.7 343.5 113.3c-32.1 20.2-66.7 46.2-95.4 71.5-15.4 13.6-46.4 44.5-60.9 60.7C83.9 361 19.9 506.6 5 660 1.8 693.3.9 747.5 3 778.5c12.3 179.4 86.4 343 212.5 469 93.2 93.2 207.7 158.7 334.5 191.4 60.1 15.5 115.7 22.4 180.5 22.4 47.3.1 80.4-2.6 123.2-9.8 146.8-25 280.7-93.2 388.2-198 56.2-54.8 104.8-121 141.1-192 90.7-177.9 103.7-389.4 35.5-577.5-18.2-50.2-43-100.6-71.6-145.2-47.6-74.6-108.4-139.7-179.9-193C1053.3 61.1 917.7 11.5 777 3c-23.9-1.4-41.1-1.6-70-.8zm81.5 65.2c67.8 6.1 131.4 21.2 192.1 45.7 85.6 34.5 159.5 83.7 224.6 149.5 20.8 21 30.6 32 47.7 53.4 76.3 95.2 125.3 211.2 140 331.5 4.2 34.2 4.6 41.4 4.6 84.5-.1 45.5-.9 58.9-6.1 95-27.8 194.4-140.2 366.6-307.4 470.7-88.5 55.1-183.7 87.1-292 98-22.2 2.2-95.1 2.5-115.5.5-33.1-3.3-57.3-6.9-81-11.8-114.4-23.9-218-76-306.5-154.1-14.7-12.9-46.2-44.5-58.6-58.8-88.8-101.9-144-225.2-160.3-358-3.7-30-4.6-45.5-4.5-82 0-36.4.8-50.7 4.5-81.5 15.7-130.9 69.6-252.2 157.5-355 12.6-14.8 52.6-54.8 67.4-67.4 95.2-81.4 205.1-133.1 326.5-153.5 22.8-3.9 44.9-6.2 80.5-8.5 12.4-.8 70.7.4 86.5 1.8z"/><path fill="currentColor" d="M429.3 320.4c-39 7.5-69.4 37.7-76.9 76.4-2 10.3-1.8 25.9.5 36.7 7.1 34.4 33.4 62.5 68.2 72.5 10.6 3.1 31.6 3.9 43 1.5 35.3-7.1 62.7-32.5 73.5-68 2.5-8.2 2.7-10.5 2.8-25 0-19.1-1.6-26.5-9.3-42-12.3-24.8-35.2-43.5-61.6-50.5-10.3-2.8-30-3.5-40.2-1.6zm27.9 64.2c5.5 1.8 12.9 8 16.2 13.7 3.6 6.2 5.1 15.1 3.7 21.9-5 24-33.1 33.6-52.3 17.8-2.1-1.8-5.1-5.9-7-9.8-2.9-5.8-3.3-7.6-3.2-14.2 0-9.5 2.7-15.9 9.2-22.3 9-8.8 20.2-11.2 33.4-7.1zM375.5 541.9c-8.7 2.2-16.6 8.3-21 16.2l-3 5.4v495l2.3 4.3c3.5 6.6 8.8 11.9 15 14.9l5.7 2.8h143l5-2.5c7.3-3.5 13.8-10.5 16.4-17.3l2.1-5.8V567.1l-2.1-5.6c-2.5-6.7-9.4-14.1-16.4-17.5l-5-2.5-69.5-.2c-38.2-.1-70.8.2-72.5.6zM478 811v206h-64V605h64v206zM629.4 541.9c-9.1 2.3-16.9 8.4-21.6 17.3l-2.3 4.3v495l2.3 4.3c3.5 6.6 8.8 11.9 15 14.9l5.7 2.8h142l6.7-3.3c7.2-3.5 12.4-8.8 15.5-15.8 1.7-3.6 1.8-12.3 2.3-133.9l.6-130 2.2-7.3c9.1-29.7 33.1-51.9 61.6-57.1 7.6-1.4 22.6-1.4 30.2 0 28.5 5.2 52.5 27.4 61.6 57.1l2.2 7.3.6 130c.5 121.6.6 130.3 2.3 133.9 3.1 7 8.3 12.3 15.5 15.8l6.7 3.3h142l5.7-2.8c6.2-3 11.5-8.3 15-14.9l2.3-4.3v-152c0-169.7.4-158.4-7.1-187.5-21.1-81-85.1-146.2-165.9-168.8-57.1-16-110.3-10.5-165.2 17.2-5.1 2.5-9.5 4.6-9.8 4.6-.3 0-.5-1.1-.5-2.5 0-4.1-3.8-13-7.5-17.3-2.2-2.5-6.3-5.4-10.3-7.4l-6.7-3.3-69-.2c-37.9 0-70.4.2-72.1.6zm102.8 80.3c.3 15.7.5 17.7 2.6 22 5.3 10.8 15 17 27.4 17.6 6.6.4 8.4 0 13.4-2.2 3.1-1.5 8.9-5.5 12.8-9 25-22.3 52.7-36.3 84.9-42.8 9.7-2 14.1-2.3 33.7-2.2 19.4 0 23.9.3 33 2.3 38.2 8.1 72.1 27.4 96.2 54.6 21.4 24.2 35.8 53.6 42 85.8 2.1 11 2.2 13.1 2.5 139.9l.4 128.8H1017V907.2c0-122.9.2-118.5-7.1-140.7-16.2-48.9-56.6-84.7-108.2-95.7-14.5-3.1-39.9-3.1-54.4 0-56.8 12.2-98.2 52.7-112.6 110.2-2.1 8.4-2.1 10.3-2.4 122.2l-.4 113.8H668V605h63.9l.3 17.2z"/></svg>
        </a>
      </li>
    </template>
  </ul>
</template>

<script>
import LangSelector from '@/components/ui/LangSelector.vue';
import useI8n from '@/composables/useI8n';

export default {
  name: 'MenuUtils',
  components: {
    LangSelector,
  },

  props: {
    isSocialIcons: {
      type: Boolean,
      default: false,
    },

    isLightMode: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    const { isLoadingLang, language, locale } = useI8n();
    return {
      isLoadingLang,
      language,
      locale,
    };
  },

  methods: {
    onLangSelection(event) {
      this.language = event.target.value;
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-utils {
  a, li {
    display: inline-flex;
  }

  li {
    margin-left: auto;

    &.util-language {
      margin-left: 0;

      @media (min-width: 320px) {
        margin-left: auto;
      }
    }

    @media (min-width: 460px) {
      margin-left: 2.4em;
    }
  }

  &.light-mode {
    .lang-selector {
      color: lighten($dark-grey, 15%);
      border-color: lighten($dark-grey, 15%);
      background-image: url(caret-svg(lighten($dark-grey, 15%)));

      &:hover, &:focus {
        color: $black;
        border-color: $black;
        background-image: url(caret-svg($black));
      }
    }
  }

  .util-social a {
    color: currentColor;
    border-radius: 50%;

    &:focus {
      box-shadow: 0 .2em .6em lighten($secondary, 10%);
    }

    &:hover, &:focus {
      color: lighten($secondary, 10%);
    }

    svg {
      display: block;
      height: 2.65em;
      width: auto;
    }
  }
}
</style>
